import React from "react";
import {useState, useEffect} from 'react';
import axios from 'axios';
import '../../Styles/Components/Persons/Preview_Person.css';
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import {useNavigate } from "react-router-dom";
import Config from '../PublicForms/Config.js';
import isTokenExpired from '../PublicForms/isTokenExpired.js';
import Navigation_Bar from "../PublicForms/Navigation_Bar.js";
import Header from "../PublicForms/Header.js";
import { ScrollToTop } from "../PublicForms/ScrollToTop.js";


export default function Add_New_Province(props) {

  const[openNav, setOpenNav] = useState(false);
  const [provinceName, setProvinceName] = useState("");
  const [runSaveData, setRunSaveData] = useState(false);
  const[message, setMessage] = useState([]);
  const[messTitle, setMessTitle] = useState("");
  const[showDialog, setShowDialog] = useState(false);
  const Navigate = useNavigate();
  const [width, setWidth] = useState(0);

  

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
    } else {
        // setUser(JSON.parse(localStorage.getItem('user')));
      }
    } else {
        Navigate("/login");
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    
    window.addEventListener("resize", handleResize)
    
    handleResize()
    
    
  }, []);

 
  const checkValidData = ()=>
  {
      
    setMessage([]);  

    if(provinceName === undefined || provinceName === null ||  provinceName === "")
      {
        setMessTitle("توجه");
        var mess = " لطفا نام استان را وارد کنید";
        var tempArr = message;
        tempArr.push(mess);
        setMessage(tempArr);
        setShowDialog(true);
      }else
      {

        setRunSaveData(true);

      }
  
  }

  useEffect(()=>
    {
      const saveData = async ()=>
      {
        axios.post(
          `${Config.apiBaseUrl}/api/Province`,{
  
  
            "provinceName": provinceName,
    
          },{headers: {
         
            "Authorization":`Bearer ${localStorage.getItem('token')}`,
          }
        }).then(response => 
          {

              if(response.status == 201)
              {
                  setMessTitle("توجه");
                  setMessage((prevMessages) => {
                      return [
                        ...prevMessages, // shallow copy into new array reference
                        "نام استان مورد نظر شما با موفقیت ثبت شد",      // append new element
                      ];
                    });
                  setShowDialog(true);
      
              }else
              {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                        ...prevMessages, // shallow copy into new array reference
                        "لطفا مجددا تلاش کنید",      // append new element
                      ];
                  });
                  setShowDialog(true);
              }
      
          }).catch((err) =>{
            
            if(err.response !== null && err.response !== undefined)
              {
                  setMessage([]);
                  if(err.response.status == 401)
                  {
                      Navigate("/login");
      
      
                  }else if((err.response.status)==500)
                  {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              (err.response.detail),      // append new element
                          ];
                      });
                      setShowDialog(true);
          
                  }else
                  {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "لطفا مجددا تلاش کنید",      // append new element
                          ];
                      });
                      setShowDialog(true);
          
                  }
      
              }else if(err.message == "Network Error")
              {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                        ...prevMessages, // shallow copy into new array reference
                        "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                      ];
                  });
                  setShowDialog(true);
              }else
              {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                          ...prevMessages, // shallow copy into new array reference
                          ("لطفا مجددا تلاش کنید"),      // append new element
                      ];
                  });                
                  
                  setShowDialog(true);
             }
              
              
         })
  
      }
     
     if(runSaveData === true)
     {
      saveData();
      setRunSaveData(false);
  
     }
  
    },[runSaveData]);
  
  const closeOpenDialog = (open) =>
    {
  
          setMessage([]);
          setShowDialog(false);
            
    }

    const handleNave = ()=>
    {
        setOpenNav(!openNav);
  
    }

    const handleNaveForm = ()=>
    {
        if(!openNav)
        {
            setOpenNav(!openNav)
        }
    }
    

    if(width >999)
    {
      return(

        <div className='prevPerson' >
                   <ScrollToTop />

              <Header />

                <div className="navClass">
                        <Navigation_Bar />
                    
                </div>
                    
                    
          <div className='prevPersonContainer'>
                  <div className='row'>
                      <div className='col-md-1'></div>

                      <div className='col-md-11 prevPersonForm'>
                        <div className="row">

                            <div className="col-sm-6 col-md-4 form-group">
                                      <label htmlFor="name"> نام استان:</label>
                                      <input type="text" className="form-control" id="name" onChange={(e)=> setProvinceName(e.target.value)} />
                              </div>
                          </div>
                      </div>
                   </div>
                   <div className='buttonContainer'>

                      <button type="button"  autoFocus onClick={()=>checkValidData()}>
                          ثبت
                      </button>

                   </div>
                  
            {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
          </div>
        </div>
      )
    }else
    {
      return(

        <div className='prevPerson-all-responsive'>

            <div className= {openNav? "navClass" : "navClass navClassOpen"}>                                

              <Navigation_Bar />
                                
            </div>

            <div className='prevPerson' >
              
                  <Header handleNave={handleNave}/>
                        
              <div className='prevPersonContainer' onClick={()=>handleNaveForm()}>
                      <div className='row'>
                          <div className='col-md-1'></div>

                          <div className='col-md-11 prevPersonForm'>
                            <div className="row">

                                <div className="col-sm-6 col-md-4 form-group">
                                          <label htmlFor="name"> نام استان:</label>
                                          <input type="text" className="form-control" id="name" onChange={(e)=> setProvinceName(e.target.value)} />
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className='buttonContainer'>

                          <button type="button" autoFocus onClick={()=>checkValidData()}>
                            ثبت
                          </button>
                          

                      </div>

                {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
              </div>
            </div>
        </div>
      )
    }
   

}